module.exports = __webpack_public_path__ + "img/img_45@2x.8aa028f2.png";